import { render, staticRenderFns } from "./BankWithdrawal.vue?vue&type=template&id=3bdb00dc&scoped=true&"
import script from "./BankWithdrawal.vue?vue&type=script&lang=js&"
export * from "./BankWithdrawal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdb00dc",
  null
  
)

export default component.exports